module.exports = __webpack_public_path__ + "static/media/clutch_badge_design.5da66d61.png";